<template>
  <my-dialog
    @hideMask="$emit('update:restartConfirmDialogFlag', false)"
    :dialogFlag="restartConfirmDialogFlag"
    width="400px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="restart_confirm_container">
      <div class="restart_confirm_container_header">
        <h3 class="header_title">重启客户端</h3>
        <div class="close_btn" @click="$emit('update:restartConfirmDialogFlag', false)">
          <img src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png" alt="关闭">
        </div>
      </div>
      <div class="restart_confirm_container_body">
        <img src="https://image.zhihuishu.com/zhs/b2cm/base1/202309/3ddf9be53bc5459d8958bcf7dd570455.png" alt="重启客户端">
        <p>确认重启客户端吗？</p>
        <p>重启期间课堂画面无法录制！</p>
      </div>
      <div class="restart_confirm_container_footer">
        <div class="cancel_btn" @click="$emit('update:restartConfirmDialogFlag', false)">取消</div>
        <div class="confirm_btn" @click="handleConfirm">重启</div>
      </div>
    </div>
  </my-dialog>
</template>

<script>
export default {
  name: 'restartConfirm',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  props: {
    restartConfirmDialogFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleConfirm () {
      this.$emit('handleRestartConfirm')
      this.$emit('update:restartConfirmDialogFlag', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  .restart_confirm_container {
    .restart_confirm_container_header {
      width: 100%;
      height: 60px;
      border-radius: 8px 8px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px;
      border-bottom: 2px solid #EAEAEA;
      .header_title {
        font-size: 16px;
        font-weight: 500;
        color: #1E2228;
      }
      .close_btn {
        width: 12px;
        height: 12px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    .restart_confirm_container_body {
      width: 100%;
      height: 245px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 120px;
        height: 120px;
        display: block;
        margin-bottom: 20px;
      }
      p {
        font-size: 16px;
        color: #0C0B22;
      }
    }
    .restart_confirm_container_footer {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border-top: 2px solid #EAEAEA;
      display: flex;
      justify-content: center;
      .cancel_btn,
      .confirm_btn {
        width: 96px;
        height: 40px;
        border-radius: 4px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
      }
      .cancel_btn {
        border: 1px solid #5F60D3;
        color: #5F60D3;
        margin-right: 16px;
        &:hover {
          background-color: #F5F5F5;
        }
        &:active {
          background-color: #FFF;
        }
      }
      .confirm_btn {
        background-color: #FF504F;
        color: #FFF;
        &:hover {
          background-color: #db4242;
        }
        &:active {
          background-color: #FF504F;
        }
      }
    }
  }
</style>